import { DELETE, GET, PATCH, POST } from '../common/common.service'
import endpointsRoles from './endpoints'

const RolesService = {
  getAll: async ({ filter, sort, limit, skip }) =>
    GET(endpointsRoles.LOAD(filter, sort, limit, skip)),
  getById: async (id) => GET(endpointsRoles.BY_ROLE(id)),
  create: async (body) => POST(endpointsRoles.CREATE, body),
  update: async ({ _id, body }) => PATCH(endpointsRoles.BY_ROLE(_id), body),
  remove: async (id) => DELETE(endpointsRoles.BY_ROLE(id)),
}

export default RolesService
